"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlagSize = exports.FlagShape = exports.FlagType = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var IDUtils_1 = require("../../utils/IDUtils");
var FlagIconUtils_1 = require("../../utils/FlagIconUtils");
var FlagType;
(function (FlagType) {
    FlagType["AVATAR"] = "avatar";
    FlagType["STANDARD"] = "standard";
})(FlagType = exports.FlagType || (exports.FlagType = {}));
var FlagShape;
(function (FlagShape) {
    FlagShape["CIRCLE"] = "circle";
    FlagShape["RECTANGLE"] = "rectangle";
    FlagShape["SQUARE"] = "square";
})(FlagShape = exports.FlagShape || (exports.FlagShape = {}));
var FlagSize;
(function (FlagSize) {
    FlagSize["SMALL"] = "small";
    FlagSize["MEDIUM"] = "medium";
    FlagSize["LARGE"] = "large";
})(FlagSize = exports.FlagSize || (exports.FlagSize = {}));
var FlagIcon = function (props) {
    var classes = props.classes, description = props.description, disabled = props.disabled, name = props.name, onClick = props.onClick, size = props.size, shape = props.shape, title = props.title, type = props.type, otherProps = __rest(props, ["classes", "description", "disabled", "name", "onClick", "size", "shape", "title", "type"]);
    if (!FlagIconUtils_1.isIconNameValid(name)) {
        throw new Error("Invalid flag icon name provided: \"" + name + "\". Please provide a valid ISO 3166 alpha-2 country code.");
    }
    var titleId = title ? IDUtils_1.generateRandomId() : '';
    var descriptionId = description ? IDUtils_1.generateRandomId() : '';
    var useAltText = (description || title);
    var ariaHidden = !useAltText;
    var ariaLabelledBy = useAltText ? (titleId + " " + descriptionId).trim() : undefined;
    var normalizedFlagShape = normalizeFlagShape(shape, type);
    return (react_1.default.createElement("span", __assign({ className: getClassNames(classes, disabled, name, normalizedFlagShape, size, type), onClick: onClick }, otherProps),
        react_1.default.createElement("svg", { role: "img", className: "fds-icon-svg", "aria-labelledby": ariaLabelledBy, "aria-hidden": ariaHidden, key: name },
            title && react_1.default.createElement("title", { id: titleId }, title),
            description && react_1.default.createElement("desc", { id: descriptionId }, description),
            react_1.default.createElement("use", { xlinkHref: "#" + type + "-" + name }))));
};
FlagIcon.defaultProps = {
    type: FlagType.STANDARD
};
var getClassNames = function (classes, disabled, name, shape, size, type) {
    var _a;
    return classnames_1.default('fds-icon', 'fds-icon-flag', "fds-icon-name-" + type.toLowerCase() + "-" + name.toUpperCase(), type, (_a = {},
        _a[size && size.toLowerCase()] = size,
        _a[shape && shape.toLowerCase()] = shape && shape !== FlagShape.RECTANGLE,
        _a['is-disabled'] = disabled,
        _a), classes);
};
var normalizeFlagShape = function (shape, type) {
    if (type === FlagType.AVATAR && (shape !== FlagShape.CIRCLE && shape !== FlagShape.SQUARE)) {
        return FlagShape.SQUARE;
    }
    else if (type === FlagType.STANDARD && shape !== FlagShape.RECTANGLE) {
        return FlagShape.RECTANGLE;
    }
    return shape;
};
exports.default = FlagIcon;
